<template>
  <div class="login-page" :style="{ 'background-image': `url(${bgImg})` }">
    <div class="app-container">
      <div id="registerContainer" style="text-align: center">
        <div class="header-container">
          <img
            name="logoIcon"
            src="../../../public/invite/apphi@3x.png"
            class="logo"
            @click="homePage"
          />
          <div name="logoIcon" class="right-message" @click="homePage">
            <div>World's best</div>
            <div>Instagram manager</div>
          </div>
        </div>
        <div class="form-title">{{ formTitle }}</div>
        <div class="form-group">
          <template v-if="$route.query.type === 'create'">
            <div class="form-item">
              <input
                v-model="createForm.email"
                autocomplete="off"
                placeholder="Email"
              />
            </div>
            <div class="form-item">
              <input
                v-model="createForm.confirm"
                autocomplete="off"
                placeholder="Confirm Email Again"
              />
            </div>
            <div class="form-item">
              <input
                v-model="createForm.password"
                autocomplete="off"
                type="password"
                placeholder="Password"
              />
            </div>
            <div>
              <button
                class="submit-btn"
                style="margin-top: 18px"
                @click="registerClick"
              >
                Sign Up
              </button>
            </div>
            <div class="tip-message">
              By joining, you agree on our
              <span class="click-able" @click="termsPage">Terms</span> and
              <span class="click-able" @click="privacyPage">Privacy Policy</span
              >.
            </div>
            <div
              class="tip-message"
              style="margin-top: 20px; font-size: 14px; font-weight: 500"
            >
              <span>Already have an account? </span>
              <span class="click-able" @click="toLoginPage">Login here</span>
            </div>
          </template>
          <template v-else>
            <div class="form-item">
              <input
                v-model="loginForm.email"
                autocomplete="off"
                placeholder="Email"
              />
            </div>
            <div class="form-item">
              <input
                v-model="loginForm.password"
                type="password"
                autocomplete="off"
                placeholder="Password"
              />
            </div>
            <div>
              <button
                class="submit-btn"
                style="margin-top: 18px"
                @click="loginClick"
              >
                Login
              </button>
            </div>
            <div class="tip-message forgot-password">Forgot password?</div>
            <button
              class="submit-btn register"
              style="margin-top: 18px"
              @click="toCreatePage"
            >
              Create Account For Free
            </button>
          </template>
        </div>
        <div style="color: white; font-size: 14px; margin-top: 45px">
          Trusted by top brands & publisher
        </div>
        <div class="logos-container">
          <img
            src="../../../public/logos/logo_stregis@3x.png"
            style="height: 27px"
          />
          <img
            src="../../../public/logos/logo_sheraton@3x.png"
            style="height: 30px"
          />
          <img
            src="../../../public/logos/logo_yelp@3x.png"
            style="height: 27px"
          />
          <img
            src="../../../public/logos/logo_home@3x.png"
            style="height: 30px"
          />
          <img
            src="../../../public/logos/logo_davidoff@3x.png"
            style="height: 29px"
          />
          <img
            src="../../../public/logos/logo_levis@3x.png"
            style="height: 30px"
          />
          <img
            src="../../../public/logos/logo_clips@3x.png"
            style="height: 30px"
          />
          <img
            src="../../../public/logos/logo_pubity@3x.png"
            style="height: 30px"
          />
        </div>
      </div>
    </div>
    <div class="web-container">
      <div class="apphi-logo" @click="homePage"></div>
      <div class="login-container">
        <div class="left-container">
          <div class="title-container">Trusted by top brands & publishers</div>
          <div class="login-logo-container center" style="margin-top: 37px">
            <img
              src="../../../public/logos/logo_stregis@3x.png"
              style="height: 26px"
            />
          </div>
          <div class="login-logo-container center" style="margin-top: 32px">
            <img
              src="../../../public/logos/logo_sheraton@3x.png"
              style="height: 32px"
            />
          </div>
          <div class="login-logo-container" style="margin-top: 36px">
            <img
              src="../../../public/logos/logo_yelp@3x.png"
              style="height: 32px"
            />
            <img
              src="../../../public/logos/logo_home@3x.png"
              style="height: 32px"
            />
            <img
              src="../../../public/logos/logo_davidoff@3x.png"
              style="height: 32px"
            />
          </div>
          <div class="login-logo-container" style="margin-top: 36px">
            <img
              src="../../../public/logos/logo_levis@3x.png"
              style="height: 28px"
            />
            <img
              src="../../../public/logos/logo_clips@3x.png"
              style="height: 32px"
            />
            <img
              src="../../../public/logos/logo_pubity@3x.png"
              style="height: 32px"
            />
          </div>
        </div>
        <div class="login-right-container">
          <div class="form-title">{{ formTitle }}</div>
          <template v-if="$route.query.type === 'create'">
            <div class="form-item">
              <input
                v-model="createForm.email"
                autocomplete="off"
                placeholder="Email"
              />
            </div>
            <div class="form-item">
              <input
                v-model="createForm.confirm"
                autocomplete="off"
                placeholder="Confirm Email Again"
              />
            </div>
            <div class="form-item">
              <input
                v-model="createForm.password"
                autocomplete="new-password"
                type="password"
                placeholder="Password"
              />
            </div>
            <div class="button login" @click="registerClick">Sign Up</div>
            <div class="tip create">
              By joining, you agree on our
              <span class="click" @click="termsPage">Terms</span> and
              <span class="click" @click="privacyPage">Privacy Policy</span>
            </div>
            <div class="create-login-tip">
              <span>Already have an account? </span>
              <span class="login-click" @click="toLoginPage">Login here</span>
            </div>
          </template>
          <template v-else>
            <div class="form-item">
              <input
                v-model="loginForm.email"
                autocomplete="off"
                placeholder="Email"
              />
            </div>
            <div class="form-item">
              <input
                v-model="loginForm.password"
                type="password"
                autocomplete="new-password"
                placeholder="Password"
              />
            </div>
            <div class="button login" @click="loginClick">Login</div>
            <div class="tip password" @click="forgotPage">Forgot password?</div>
            <div class="button create-free" @click="toCreatePage">
              Create Account For Free
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/style/theme";

.login-page {
  width: 100%;
  min-height: 100vh;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;

  .app-container {
    @media (min-width: 800px) {
      display: none;
    }
    min-height: 100vh;

    .header-container {
      align-items: center;
      width: 100vw;
      justify-content: center;
      margin-top: 20px;
      display: flex;
    }

    .header-container.pc {
      width: 420px;
    }

    .header-container [name="logoIcon"] {
      cursor: pointer;
    }

    .header-container .logo {
      height: 40px;
      margin-right: 5px;
    }

    .header-container .right-message {
      display: inline-block;
      border-left: 1px solid rgba(255, 255, 255, 0.3);
      padding-left: 10px;
      font-size: 14px;
      color: white;
      text-align: left;
    }

    .sign-title {
      margin-top: 60px;
      font-size: 26px;
      text-align: center;
    }

    .form-title {
      font-size: 26px;
      text-align: center;
      color: white;
      margin-top: 50px;
    }

    .form-group {
      width: 300px;
      max-width: 90vw;
      text-align: center;
      display: inline-block;
      margin-top: 20px;
    }

    .form-item {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      box-sizing: border-box;
    }

    .form-item input {
      background: transparent;
      border: 0;
      color: white;
      height: 55px;
      font-size: 16px;
      text-align: center;
      width: 100%;
      outline: none;
      box-sizing: border-box;
      vertical-align: middle;
    }

    .form-item input::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: rgba(255, 255, 255, 0.6);
    }

    .form-item input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: rgba(255, 255, 255, 0.6);
    }

    .form-item input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: rgba(255, 255, 255, 0.6);
    }

    .form-item input:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: rgba(255, 255, 255, 0.6);
    }

    .submit-btn {
      width: 100%;
      height: 53px;
      background: @theme-color;
      border-radius: 4px;
      font-size: 16px;
      border: 0;
      color: white;
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;

      &.register {
        border: 2px solid white;
        background: transparent;
      }
    }

    .submit-btn:hover {
      opacity: 0.7;
    }

    .tip-message {
      text-align: center;
      font-size: 12px;
      margin-top: 12px;
      color: white;

      &.forgot-password {
        margin-top: 15px;
        cursor: pointer;

        &:hover {
          opacity: 0.7;
        }
      }
    }

    .tip-message .click-able {
      cursor: pointer;
      text-decoration: underline;
    }

    .logos-container {
      min-height: 30px;
      line-height: 30px;
      text-align: center;
      margin: 15px auto 0 auto;
      max-width: 500px;
    }

    .logos-container img {
      margin: 0 15px 10px 15px;
    }

    .success-container {
      margin-top: 136px;
    }

    .success-container .first {
      font-size: 26px;
    }

    .success-container .second {
      font-size: 18px;
      margin-top: 5px;
    }
  }

  .web-container {
    @media (max-width: 800px) {
      display: none;
    }

    .apphi-logo {
      height: 44px;
      position: absolute;
      left: 47px;
      top: 43px;
      background-image: url(../../../public/invite/apphi@3x.png);
      width: 116px;
      background-size: contain;
      cursor: pointer;

      :hover {
        opacity: 0.7;
      }
    }

    .login-container {
      width: 732px;
      display: flex;

      .left-container {
        width: 274px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 8px 0 0 8px;

        .login-logo-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 29px;

          &.center {
            justify-content: center;
          }
        }

        .title-container {
          font-size: 18px;
          margin-top: 55px;
          text-align: center;
          color: white;
        }
      }

      .login-right-container {
        flex: 1;
        background: white;
        border-radius: 0 8px 8px 0;
        padding: 0 37px;
        height: 426px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .form-title {
          font-size: 28px;
          color: #4a4a4a;
          text-align: center;
          margin-bottom: 28px;
        }

        .form-item {
          height: 55px;
          border-bottom: 1px solid rgba(210, 210, 210, 0.31);

          input {
            background: transparent;
            border: 0;
            height: 55px;
            font-size: 16px;
            text-align: center;
            width: 100%;
            outline: none;
            box-sizing: border-box;
            vertical-align: middle;
          }
        }
      }
    }

    .tip {
      color: #8c8c8c;
      font-size: 12px;
      margin-top: 15px;

      &.password {
        text-align: right;
        cursor: pointer;

        &:hover {
          opacity: 0.7;
        }
      }

      &.create {
        text-align: center;
      }

      .click {
        cursor: pointer;

        &:hover {
          opacity: 0.7;
        }
      }
    }

    .create-login-tip {
      font-size: 14px;
      margin-top: 20px;
      text-align: center;

      .login-click {
        color: @theme-color;
        text-decoration: underline;
        cursor: pointer;

        &:hover {
          opacity: 0.7;
        }
      }
    }

    .button {
      height: 53px;
      background-color: @theme-color;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }

      &.login {
        margin-top: 20px;
      }

      &.create-free {
        border-radius: 4px;
        border: solid 2px @theme-color;
        color: @theme-color;
        background: transparent;
        margin-top: 20px;
      }
    }
  }
}
</style>
<script>
import { apphiLogin, autoLogin, register } from "../../service/user";
import { list as planList } from "../../service/plans";
import { showErrorMsg, initValidateByPromise } from "../../utils/errors";
import { validateCurrentPublisherStatus } from "../../service/publisher";
import bgImg from "../../../public/invite/login_bg@3x.png";
import { getDevice } from "../../utils";
export default {
  name: "LoginPage",
  data() {
    return {
      bgImg,
      createForm: {
        email: "",
        confirm: "",
        password: "",
      },
      loginForm: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    formTitle() {
      if (this.$route.query.type === "login" || !this.$route.query.type) {
        return "Login";
      } else {
        return "Create Account";
      }
    },
  },
  methods: {
    homePage() {
      window.open(`${process.env.VUE_APP_HOME_URL}`, "_blank");
    },
    async loginClick() {
      const loading = this.$loading();
      try {
        if (!this.loginForm.email && !this.loginForm.password) {
          await initValidateByPromise("Cannot be empty.");
        }
        // 登录
        await apphiLogin({
          username: this.loginForm.email,
          password: this.loginForm.password,
        });
        // 如果不是web則停止後續邏輯
        if (!this.validateDevice()) {
          return;
        }
        await planList();
        // 登录成功后跳转schedule post页
        this.$router.push({ name: "SchedulePage" });
        // 验证当前publisher 是否需要验证
        validateCurrentPublisherStatus();
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 如果發現是移動端則彈出提示
     */
    validateDevice() {
      const device = getDevice();
      if (device !== "web") {
        this.$router.push({ name: "DesktopValidatePage" });
        return false;
      }
      return true;
    },
    /**
     * 注册点击事件
     */
    async registerClick() {
      const loading = this.$loading();
      try {
        if (
          !this.createForm.email &&
          !this.createForm.confirm &&
          !this.createForm.password
        ) {
          await initValidateByPromise("Cannot be empty.");
        }
        // 2次验证邮箱不相同
        if (
          this.createForm.email.toLowerCase() !==
          this.createForm.confirm.toLowerCase()
        ) {
          await initValidateByPromise("Both emails must be the same.");
        }
        // 密码大于6位
        if (this.createForm.password.length < 6) {
          await initValidateByPromise(
            "Password must have minimum 6 characters."
          );
        }
        await register(this.createForm);
        // 如果不是web則停止後續邏輯
        if (!this.validateDevice()) {
          return;
        }
        await planList();
        // 登录成功后跳转schedule post页
        this.$router.push({ name: "SchedulePage" });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    toCreatePage() {
      this.$router.push({ name: "LoginPage", query: { type: "create" } });
    },
    /**
     * 去登录页面
     */
    toLoginPage() {
      this.$router.push({ name: "LoginPage", query: { type: "login" } });
    },
    privacyPage() {
      window.open(
        `${process.env.VUE_APP_HOME_URL}/privacy-policy.html`,
        "_blank"
      );
    },
    termsPage() {
      window.open(`${process.env.VUE_APP_HOME_URL}/tos.html`, "_blank");
    },
    forgotPage() {
      window.open(`${process.env.VUE_APP_CHANGE_PASSWORD}`, "_blank");
    },
  },
  async created() {
    const auth = this.$route.query.auth;
    // 判断如果存在token则说明直接免登
    if (auth) {
      const loading = this.$loading();
      try {
        await autoLogin({ auth });
        await planList();
        // 登录成功后跳转schedule post页
        this.$router.push({ name: "SchedulePage", query: { first: 1 } });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    }
  },
};
</script>
